
    import './styles.scoped.css';
    export default {
  "cell": "awsui_cell_2seex_ko0nv_5",
  "cell-grid": "awsui_cell-grid_2seex_ko0nv_33"
};
  